import React from 'react';
import { directDeepLink, SOURCE_HOME, SOURCE_WEBVIEW } from '../../util';
import './ToolsInt.css';
import { cosmosTrackService } from '../../../../cosmosTracking/cosmosTrackService';
import { tutorDetailsToolsConfig, resolveTutorDetailsToolsAsset } from './tutorDetailsToolsConfig';


import {
	create_and_share_poster,
	create_polls,
	Tips_from_experts,
	send_notification
} from '../../../../cosmosTracking/cosmosEvents';

function ToolCardInt(props) {
	const { data } = props;
	const images = tutorDetailsToolsConfig.images || {};
	const toolIcons = images.tool_icons || [];

	function isMobile() {
		const userAgent = navigator.userAgent || navigator.vendor || window.opera;
		return /android/i.test(userAgent) || /iPhone|iPad|iPod/i.test(userAgent);
	}

	const handleClick = (tool, index) => {
		let eventType;
		switch (index) {
			case 0:
				eventType = create_and_share_poster;
				break;
			case 1:
				eventType = create_polls;
				break;
			case 2:
				eventType = Tips_from_experts;
				break;
			case 3:
				eventType = send_notification;
				break;
			default:
				return;
		}

		cosmosTrackService(eventType);

		if (isMobile()) {
			if (index === 2 || index === 3) {
				directDeepLink(tool?.deeplink, SOURCE_HOME, SOURCE_WEBVIEW);
			} else {
				directDeepLink(tool?.deeplink, SOURCE_HOME);
			}
		} else {
			window.top.postMessage({ url: tool?.deeplink?.weblink }, '*');
		}
	};

	return (
		<>
			{data?.map((tool, index) => (
				<div
					key={index}
					className="tool-card-box"
					onClick={(e) =>{
						e.stopPropagation();
						handleClick(tool, index)}}>
					{index === 0 && <img src={resolveTutorDetailsToolsAsset(toolIcons[0] || 'https://cdn-wl-assets.classplus.co/production/379965/a27c7b8f-b0af-406e-8110-270a1356a623.png')} alt="Create" width={28} height={28} />}
					{index === 1 && <img src={resolveTutorDetailsToolsAsset(toolIcons[1] || 'https://cdn-wl-assets.classplus.co/production/379965/a053a3a5-4e5e-4809-b5cc-ff005129fb03.png')} alt="Tip & Tricks" width={28} height={28} />}
					{index === 2 && <img src={resolveTutorDetailsToolsAsset(toolIcons[2] || 'https://cdn-wl-assets.classplus.co/production/379965/9a6a57f9-f1e1-4be7-9e99-7d6cd139a203.png')} alt="Create" width={28} height={28} />}
					{index === 3 && <img src={resolveTutorDetailsToolsAsset(toolIcons[3] || 'https://cdn-wl-assets.classplus.co/production/379965/a700b911-0f97-4b80-8d0c-4c54a97501b7.png')} alt="Notifications" width={28} height={28} />}
					<h4>{tool?.text}</h4>
					<img src={resolveTutorDetailsToolsAsset(images.card_arrow_icon || 'https://cdn-wl-assets.classplus.co/production/379965/aa473d7f-de7b-44b9-a575-b177e194a740.png')} alt="arrow" width={16} />
				</div>
			))}
		</>
	);
}

export default ToolCardInt;
